export type ImageRenderMeta = {
  width: number;
  height: number;
};

const fixedMeta = (width: number, height: number): ImageRenderMeta => ({ width, height });

const IMAGE_META: Record<string, ImageRenderMeta> = {
  "/onboarding_lander_science.webp": fixedMeta(900, 502),
  "/romain_skyline.webp": fixedMeta(900, 491),
  "/romain_skyline.avif": fixedMeta(900, 491),
  "/roman_republic.webp": fixedMeta(900, 491),
  "/pirate_engineering.webp": fixedMeta(900, 590),
  "/pirate_engineering.avif": fixedMeta(900, 590),
  "/science_lightspeed.webp": fixedMeta(900, 491),
  "/roman_gladiators.webp": fixedMeta(900, 491),
  "/pysch_representation.webp": fixedMeta(900, 502),
  "/pysch_representation.avif": fixedMeta(900, 502),
  "/science_ac.webp": fixedMeta(900, 491),
  "/history_julius_caesar.webp": fixedMeta(900, 491),
  "/high_court.webp": fixedMeta(900, 491),
  "/science_preindustrial_engineering.webp": fixedMeta(900, 491),
  "/science_chemicals.webp": fixedMeta(1100, 600),
  "/persona_shepard.webp": fixedMeta(1100, 575),
  "/persona_disciple.webp": fixedMeta(1100, 575),
  "/persona_wanderer.webp": fixedMeta(1100, 575),
  "/persona_scribe.webp": fixedMeta(1100, 614),
  "/persona_prophet.webp": fixedMeta(1100, 575),
  "/persona_berean.webp": fixedMeta(1100, 614),
  "/characters_1.webp": { width: 500, height: 809 },
  "/characters_2.webp": { width: 500, height: 750 },
  "/characters_3.webp": { width: 500, height: 757 },
  "/characters_4.webp": { width: 500, height: 732 },
  "/vireo/background.jpg": fixedMeta(1200, 800),
  "/vireo/Collateral/phone-in-hand.webp": fixedMeta(1024, 1536),
  "/vireo/Collateral/image-use-what-you-have.avif": fixedMeta(1024, 1536),
  "/vireo/background-2.jpg": fixedMeta(1200, 800),
  "/vireo/brand-moment-background.jpg": fixedMeta(1200, 800),
  "/vireo/Social-Preview.png": fixedMeta(1024, 518),
  "/vireo/Collateral/hero-checkout.webp": fixedMeta(1200, 604),
  "/vireo/adaptive-icon.png": fixedMeta(512, 512),
  "/vireo/mascot/mascot-quick-meals.webp": fixedMeta(492, 462),
  "/vireo/mascot/mascot-empty-search.webp": fixedMeta(800, 800),
  "/vireo/mascot/mascot-photo-of-ingredients.webp": fixedMeta(640, 601),
  "/vireo/mascot/mascot-import.webp": fixedMeta(800, 800),
  "/vireo/mascot/mascot-learning-skills.webp": fixedMeta(800, 800),
  "/vireo/mascot/mascot-family-meals.webp": fixedMeta(559, 525),
  "/vireo/mascot/mascot-scan.webp": fixedMeta(800, 800),
  "/vireo/mascot/mascot-saving-money.webp": fixedMeta(800, 800),
  "/vireo/mascot/mascot-eating-healthy.webp": fixedMeta(800, 800),
  "/sehaj/brand/sehaj-icon.png": fixedMeta(512, 512),
  "/sehaj/brand/sehaj-icon-flat.png": fixedMeta(512, 512),
  "/sehaj/Imagery/hand-reading-sikh-story.webp": fixedMeta(900, 1125),
  "/sehaj/Imagery/hand-reading-sikh-story.png": fixedMeta(900, 1125),
  "/sehaj/Imagery/warm-light-sikh-reading-room.png": fixedMeta(1402, 1122),
  "/sehaj/Imagery/popular-story-artwork.png": fixedMeta(1536, 1024),
  "/sehaj/Imagery/sikh%20man%20looking%20away%20in%20distant.png": fixedMeta(1536, 1024),
  "/sehaj/Imagery/hero-welcome-two-sikhs%20talking.png": fixedMeta(800, 1067),
  "/sehaj/Imagery/sikhs-walking-away-old-attire.webp": fixedMeta(900, 1200),
  "/sehaj/quiz/practice-intent-morning-reflection.webp": fixedMeta(900, 1125),
  "/sehaj/quiz/practice-steadiness-quiet-space.webp": fixedMeta(900, 1125),
  "/sehaj/quiz/practice-priorities-study-hands.webp": fixedMeta(900, 1125),
  "/sehaj/quiz/biggest-blocker-returning-path.webp": fixedMeta(900, 1125),
  "/sehaj/quiz/your-why-family-story.webp": fixedMeta(900, 1125),
  "/sehaj/quiz/affirmation-reflective-waterside.webp": fixedMeta(900, 1125),
  "/sehaj/quiz/bhai-lalo-honest-work-v2.webp": fixedMeta(720, 720),
  "/sehaj/quiz/bhai-lalo-tablet-landscape.webp": fixedMeta(1000, 666),
  "/sehaj/quiz/commute-phone-story.webp": fixedMeta(900, 900),
  "/sehaj/quiz/simran-morning-stillness.webp": fixedMeta(720, 720),
  "/sehaj/quiz/guidance-style-ritual-tools.webp": fixedMeta(720, 720),
  "/sehaj/quiz/guidance-depth-shared-learning.webp": fixedMeta(720, 720),
  "/sehaj/quiz/saakhi-daily-life-commute.webp": fixedMeta(720, 720),
  "/sehaj/quiz/persona-path-ready.webp": fixedMeta(720, 720),
  "/sehaj/quiz/audience-storytelling-child.webp": fixedMeta(900, 600),
  "/sehaj/paywall/daily-rhythm.webp": fixedMeta(900, 600),
  "/sehaj/paywall/bento-story-ipad.webp": fixedMeta(900, 900),
  "/sehaj/paywall/gentle-reminder.webp": fixedMeta(900, 600),
  "/sehaj/paywall/history-guru-nanak-sahib.webp": fixedMeta(1200, 800),
  "/sehaj/paywall/practice-real-life.webp": fixedMeta(900, 600),
  "/sehaj/paywall/reflection-progress.webp": fixedMeta(900, 450),
  "/sehaj/testimonials/amrit-k.webp": fixedMeta(96, 96),
  "/sehaj/testimonials/gurpreet-s.webp": fixedMeta(96, 96),
  "/sehaj/testimonials/harleen-m.webp": fixedMeta(96, 96),
  "/sehaj/testimonials/jess.webp": fixedMeta(100, 94),
  "/sehaj/app-screenshots/01-home.webp": fixedMeta(1122, 1402),
  "/sehaj/app-screenshots/02-saakhi.webp": fixedMeta(1122, 1402),
  "/sehaj/app-screenshots/03-listen.webp": fixedMeta(1122, 1402),
  "/sehaj/app-screenshots/04-reflection.webp": fixedMeta(1122, 1402),
  "/sehaj/app-screenshots/05-journey.webp": fixedMeta(1122, 1402),
  "/sehaj/welcome-dawn.svg": fixedMeta(900, 1080),
  "/sehaj/path-emblem.svg": fixedMeta(320, 320),
  "/sehaj/journey-path.svg": fixedMeta(900, 900),
  "/sehaj/scripture-glow.svg": fixedMeta(900, 900),
  "/sehaj/Elements/plant-elment-dark-beige-transparent.webp": fixedMeta(1024, 1536),
  "/sehaj/Elements/plant-elment-dark-beige-transparent.png": fixedMeta(1024, 1536)
};

export const getImageRenderMeta = (src?: string | null): ImageRenderMeta | undefined => {
  if (!src) {
    return undefined;
  }
  return IMAGE_META[src];
};

export const getImagePreloadCandidates = (src?: string | null): string[] => {
  if (!src) {
    return [];
  }

  return [src];
};

export const getImagePreloadCandidatesForSources = (
  sources?: Array<string | null | undefined>
): string[] => {
  if (!sources || sources.length === 0) {
    return [];
  }

  return Array.from(new Set(sources.flatMap((source) => getImagePreloadCandidates(source))));
};
